import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Analytics from '../../../../modules/analytics';
import ProviderProductsList from './ProviderProductsList';
import { useMount, useParams } from '../../../../hooks';
import { PublicProvider } from '../../../../api/Providers';
import type { IRootDispatch, RootState } from '../../../../store/models';
import { openExternalUrl } from '../../../../modules/openExternalUrl';
import { PROFILE_MESSAGE } from '../../../../route-names';

type ProviderProductsListContainerProps = {
  provider: Pick<PublicProvider, 'id'>;
  isEditMode?: boolean;
  onMount?: () => void;
};

/**
 * Displays a list of provider products
 * @returns {*}
 * @constructor
 */
export const ProviderProductsListContainer: React.FCWithChildren<ProviderProductsListContainerProps> = ({
  provider,
  isEditMode,
  onMount,
}) => {
  const products = useSelector<RootState, any>(state => state.providerProducts.list);
  const { addProduct: showAddProduct } = useParams();
  const dispatch = useDispatch<IRootDispatch>();

  const {
    id: providerId,
  } = provider;

  useMount(onMount);

  const handleOnShopProduct = product => {
    Analytics.track('client_clicked_affiliate_link', {
      product_clicked: product.id,
      link_clicked: product.link,
    });

    openExternalUrl(product.link);
  };

  const handleOnRequestProduct = product => {
    Analytics.track('client_clicked_affiliate_link', {
      product_clicked: product.id,
    });

    dispatch.route.go({
      route: PROFILE_MESSAGE,
      params: {
        providerId,
        message: `I'd like to purchase ${product.title}`,
      },
      notify: true,
    });
  };

  const handleOnDeleteItem = product => {
    dispatch.providerProducts.delete({ providerId, productId: product.id });
  };

  const handleOnAddItem = product => {
    dispatch.providerProducts.save({ providerId, product });
  };

  const handleOnEditItem = product => {
    dispatch.providerProducts.save({ providerId, product });
  };

  if (products.length === 0 && !isEditMode) {
    return null;
  }

  return (
    <ProviderProductsList
      products={products}
      isEditMode={isEditMode}
      showAddProduct={!!showAddProduct}
      onRequestItem={handleOnRequestProduct}
      onShopItem={handleOnShopProduct}
      onDeleteItem={handleOnDeleteItem}
      onAddItem={handleOnAddItem}
      onEditItem={handleOnEditItem}
    />
  );
};

ProviderProductsListContainer.defaultProps = {
  isEditMode: false,
  onMount: () => {},
};

export default ProviderProductsListContainer;
